import { render } from "./MessageIcon.vue?vue&type=template&id=16942b86"
import script from "./MessageIcon.vue?vue&type=script&lang=js"
export * from "./MessageIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__